/**
 * Shared contract for the frontend that mirrors the backend PollTextField schema.
 * Keeping this file synchronized with the backend interfaces ensures every consumer
 * renders/exports the same fields, which matches the Phase 1 goal of normalization.
 */
export interface IPollTextFieldSchema {
    enabled: boolean;
    question: string;
    placeholder?: string;
    required?: boolean;
    maxLength?: number;
    rows?: number;
}

export interface IPollTextFieldSubmission {
    pollTextFieldId: string;
    response: string;
    submittedAt: string;
    metadata?: Record<string, string>;
}

/**
 * Default values that keep the schema sturdy even when the backend response is incomplete.
 */
export const DEFAULT_POLL_TEXT_FIELD_SCHEMA: IPollTextFieldSchema = {
    enabled: false,
    question: "",
    placeholder: "",
    required: false,
    maxLength: 500,
    rows: 4,
};

/**
 * Normalize incoming payloads so downstream code no longer has to guard against undefined fields.
 */
export const normalizePollTextFieldSchema = (
    source?: Partial<IPollTextFieldSchema> | null
): IPollTextFieldSchema => ({
    enabled: Boolean(source?.enabled),
    question: (source?.question ?? "").trim(),
    placeholder: source?.placeholder ?? "",
    required: Boolean(source?.required),
    maxLength:
        typeof source?.maxLength === "number"
            ? source.maxLength
            : DEFAULT_POLL_TEXT_FIELD_SCHEMA.maxLength,
    rows:
        typeof source?.rows === "number"
            ? source.rows
            : DEFAULT_POLL_TEXT_FIELD_SCHEMA.rows,
});
